/* Learn capture modal (design_handoff_glass_learn L7). Opens at 55% scroll or 45s, whichever is
   first, only after the reader has passed the inline capture; once per 14 days; never for members,
   known readers, or while another modal is open or was shown this session. No exit intent. */
(function () {
  var root = document.querySelector('[data-mgl-modal]');
  if (!root) return;
  var KEY = 'ml_learn_capture_v1', DAYS14 = 14 * 864e5;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  var last = parseInt(ls(KEY), 10);
  var member = document.body.getAttribute('data-monthlees-customer-member') === 'active' || document.documentElement.getAttribute('data-ml-visitor') === 'member';
  var known = ls('pss_email') || ls('ml_lead_captured') === '1' || ss('pss_email_captured') === '1';
  if (member || known || (last && Date.now() - last < DAYS14)) return;
  var inline = document.querySelector('.ml-aoi'), passed = !inline, opened = false, lastFocus = null;
  if (inline && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { passed = true; o.disconnect(); } }); }).observe(inline);
  } else { passed = true; }
  function busy() {
    var a = document.activeElement;
    return document.documentElement.classList.contains('ml-cm-lock') || ss('ml_cm_shown') === '1' ||
      !!document.querySelector('.monthlees-modal-overlay[aria-hidden="false"], .ml-cm.is-open') ||
      (a && /INPUT|TEXTAREA|SELECT/.test(a.tagName));
  }
  var main = document.getElementById('MainContent');
  var focusables = function () { return root.querySelectorAll('button:not([hidden]), input, [href], [tabindex]:not([tabindex="-1"])'); };
  function open() {
    if (opened || !passed || busy()) return;
    opened = true; ls(KEY, String(Date.now()));
    lastFocus = document.activeElement; root.hidden = false; document.documentElement.classList.add('mgl-modal-lock');
    if (main) main.setAttribute('inert', '');
    var i = root.querySelector('input'); if (i) i.focus();
  }
  function close() {
    root.hidden = true; document.documentElement.classList.remove('mgl-modal-lock');
    if (main) main.removeAttribute('inert');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-mgl-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(focusables(), function (x) { return x.offsetParent !== null; }); if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  var form = root.querySelector('[data-mgl-modal-form]'), msg = root.querySelector('[data-mgl-modal-msg]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input'), email = (input.value || '').trim(), btn = form.querySelector('button');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.setAttribute('aria-invalid', 'true'); msg.textContent = 'Enter a valid email address.'; input.focus(); return; }
    input.removeAttribute('aria-invalid'); btn.disabled = true;
    fetch('/apps/precision/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, source: root.getAttribute('data-source') }) })
      .then(function (r) { if (!r.ok) throw 0;
        ls('pss_email', email); ls('ml_lead_captured', '1');
        root.querySelector('[data-mgl-modal-state="form"]').hidden = true;
        var d = root.querySelector('[data-mgl-modal-state="done"]'); d.hidden = false; d.querySelector('h2').focus(); })
      .catch(function () { msg.textContent = 'That did not send. Try once more in a moment.'; })
      .then(function () { btn.disabled = false; });
  });
  var due = false, iv = null;
  function tick() {
    if (opened) { clearInterval(iv); window.removeEventListener('scroll', tick); return; }
    var h = document.documentElement;
    if (due || (h.scrollTop + innerHeight) / h.scrollHeight >= 0.55) open();
  }
  setTimeout(function () { due = true; tick(); iv = setInterval(tick, 3000); }, 45000);
  window.addEventListener('scroll', tick, { passive: true });
})();
